module.exports = __webpack_public_path__ + "img/icon-budgeting.d4cdc9d6.svg";